<div [formGroup]="form" class="card secondary" id="{{rubricComponent?.Value}}">
    <div class="card-header text-white bg-secondary">
        <div class="d-flex flex-row justify-content-between">
            <h5 class="mb-0">{{rubricComponent?.Key}}. {{rubricComponent?.LongLabel}}</h5>
            <div class="text-end no-wrap">
                <a class="text-white" [href]="rubricLanguageLink" target="_blank">View Rubric Language</a>
                <edl-tooltip [icon]="EdlTooltipIcon.INFO" help="Under Act 13, the frameworks have been refreshed. The language has been revised and Discussion Prompts and Evidence of Practice have been added. Due to Copyright permissions the specific language is not embedded in the rubric assessment tool.  Click the View Rubric Language link to reference, download, and/or print the refreshed frameworks."></edl-tooltip>
            </div>
        </div>
    </div>
    <div class="card-body">
        <div *ngIf="showTargetUserRating()" class="mb-4 target-user">
            <div class="d-flex flex-row justify-content-between">
                <h5 [lg-path]="resourceFilePath"
                    [lg-key]="'TeacherRating.Text'"
                    lg-default="Employee Rating"
                ></h5>
                <label class="form-label">
                    <input type="checkbox" (change)="onCheckboxClicked(false, $event)"  [checked]="isChecked(false)" [disabled]="isResponseDisabled(false)" aria-label="Employee Rating Not Applicable"/>
                    Not Applicable
                </label>
            </div>
            <edl-proficiency-picker
                [options]="rubricResponses"
                [deselectedValue]="RubricResponse.UNSELECTED"
                [readOnly]="isChecked(false) || (observationDetails?.completed ?? false)"
                formControlName="teacherResponse">
            </edl-proficiency-picker>
        </div>

        <div *ngIf="showEvalutatorRating()" class="mb-4 evaluating-user">
            <div class="d-flex flex-row justify-content-between">
                <h5 [lg-path]="resourceFilePath"
                    [lg-key]="'PrincipalRating.Text'"
                    lg-default="Supervisor Rating"
                ></h5>
                <label class="form-label">
                    <input type="checkbox" (change)="onCheckboxClicked(true, $event)"  [checked]="isChecked(true)" [disabled]="isResponseDisabled(true)" aria-label="Supervisor Rating Not Applicable"/>
                    Not Applicable
                </label>
            </div>
            <edl-proficiency-picker
                [options]="rubricResponses"
                [deselectedValue]="RubricResponse.UNSELECTED"
                [readOnly]="isChecked(true) || (observationDetails?.completed ?? false)"
                formControlName="principalResponse">
            </edl-proficiency-picker>
        </div>
            <app-observation-comments
                [observationType]="observationType"
                [observationSummary]="observationSummary"
                [defaultDomainFilterId]="rubricComponent?.Value"
                [hideFilter]="true"
                [attachmentLabel]="'Rubric '+rubricComponent?.Value"
                [isReadOnly]="observationDetails?.completed ?? false"
                [isCommentCollapsed]="filterType !== DomainFilterType.COMPONENT && filterType !== DomainFilterType.FOCUS_AREAS"
        ></app-observation-comments>
    </div>
</div>
